import * as React from "react";
import { type ReactNode } from "react";
import classNames from "classnames";
import { Stack } from "~/common/mui";

interface ToolbarProps {
  className?: string;
  left?: ReactNode;
  right?: ReactNode;
  noBottomSpace?: boolean;
}

const PageToolbar: React.FC<ToolbarProps> = (props) => {
  const { className, left, right, noBottomSpace } = props;

  const cls = classNames(
    {
      "mb-30": !noBottomSpace,
      "scha__page__toolbar--justify-right": !left && right,
    },
    className,
    "scha__page__toolbar",
  );

  return (
    <div className={cls}>
      {wrapMultipleChildren(left)}
      {wrapMultipleChildren(right)}
    </div>
  );
};

const wrapMultipleChildren = (children: ReactNode) => {
  if (React.Children.count(children) > 1) {
    return <Stack gap={4} children={children} />;
  } else {
    return children;
  }
};

export default PageToolbar;
